import { isValid } from 'date-fns';
import { prop, isEmpty, compose, not, equals, hasPath, curry, filter, values, isNil, either, } from 'ramda';
// propIsTrue :: (String) -> ({}) -> bool
export const propIsTrue = (property) => compose(equals(true), prop(property));
// isNotFalse :: (bool) -> bool
export const isNotFalse = compose(not, equals(false));
// isEmptyOrNil :: any -> bool
export const isEmptyOrNil = either(isEmpty, isNil);
// propIsEmptyOrNil :: (String) -> ({}) -> bool
export const propIsEmptyOrNil = (property) => compose(isEmptyOrNil, prop(property));
// propIsNotEmptyOrNil :: (string) -> ({}) -> bool
export const propIsNotEmptyOrNil = (property) => compose(not, propIsEmptyOrNil(property));
// propIsNotFalse :: (String) -> ({}) -> bool
export const propIsNotFalse = (property) => compose(isNotFalse, prop(property));
// propIsFalse :: (String) -> ({}) -> bool
export const propIsFalse = (property) => compose(equals(false), prop(property));
// isIn :: ({}) -> (String) -> bool
export const isIn = (obj) => (_, key) => hasPath([key], obj);
// isNotIn :: ({}) -> (String) -> bool
export const isNotIn = (obj) => compose(not, isIn(obj));
/**
 * is value in given Object.
 *
 * (Object, any) -> bool
 */
export const isValueOf = curry((object, value) => !!filter((route) => route === value, values(object)).length);
// isNotEmpty :: any -> bool
export const isNotEmpty = compose(not, isEmpty);
// isEmptyOrNil :: any -> bool
export const isNotEmptyOrNil = compose(not, either(isEmpty, isNil));
export const isValidDateString = (dateStr) => {
    const date = new Date(dateStr);
    return isValid(date);
};
//# sourceMappingURL=conditions.js.map